import React from 'react';
import { Link } from "react-router-dom";
import Auth from "../../services/Auth.service";
import { useTranslation } from "react-i18next";
import FarmCreateComponents from "../../components/FarmsComponents/FarmCreateComponents";

export default function CreateFarm() {

    const { t } = useTranslation();

    return (
        <div>
            {Auth.isUserLoged ? <div>
                <br />
                <div className="container-fluid">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to={'/home/'}>{t("Home_Breadcrumb_Title")}</Link></li>
                                <li className="breadcrumb-item"><Link to={'/Farms/'}>{t("Global_Label_Text_Farms")}</Link></li>
                                <li className="breadcrumb-item"><Link to={'/Farms/CreateFarms'}>{t("Global_Label_Text_Add")}</Link></li>
                            </ol>
                        </nav>
                    </div>
                </div>

                <div>
                    <div>
                        <FarmCreateComponents />
                    </div>
                </div>
                <br />
            </div > : ""}
        </div>
    );

}
